import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { AudioManager } from "./AudioManager";
import { SponsorManager, WhyCallAd } from "./SponsorManager";
import { BoardState } from "./board/BoardState";
import { BoardManagerAI } from "./board/BoardManagerAI";
import { ChallengeManager } from "./challenge/ChallengeManager";

export class GameManager {

    private static game: Phaser.Game;

    public static init(game: Phaser.Game): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            LaggedAPI.init("chess_grandmaster_initgs", "lagdevaF3001");
        }

        GameManager.game = game;

        GameManager.game.load.crossOrigin = "Anonymous";

        GameVars.problemsData = GameManager.game.cache.getJSON("problems-data");

        AudioManager.init(this.game);

        GameManager.resetVars();

        GameManager.readGameStorage();

        GameVars.chess = new Chess();

        GameManager.enterHomeScene();
    }

    public static enterHomeScene(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_NONE) {

            if (top.location.href.indexOf("footchinko.com") > -1 || top.location.href.indexOf("ravalmatic.com") > -1 || top.location.href.indexOf("localhost") > -1 || top.location.href.indexOf("127") > -1) {
                GameManager.game.state.start("SplashState", true, false);
            }

        }  else if (GameConstants.SPONSOR === GameConstants.SPONSOR_IZZYGAMES) {

            // if (top.location.href.indexOf("spiele-umsonst.de") > -1 || top.location.href.indexOf("izzygames.com") > -1 || top.location.href.indexOf("localhost") > -1 || top.location.href.indexOf("192") > -1) {
                GameManager.game.state.start("SplashState", true, false);
            // }

        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

            if (window.location.href.indexOf("lagged") > -1 || top.location.href.indexOf("lagged") > -1 || window.location.href.indexOf("footchinko") > -1 || window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("192") > -1) {
                GameManager.game.state.start("SplashState", true, false);
            }
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_YANDEX) {

            SponsorManager.adFilter(() => {
                GameManager.game.state.start("SplashState", true, false);
            }, GameManager.game, WhyCallAd.onGameStart);

        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_KINAI) {

            GameManager.game.state.start("SplashState", true, false);
            
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_HUZ) {

            GameManager.game.state.start("SplashState", true, false);
        } else if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {

            GameManager.initGameDistributionSDK();
            GameManager.game.state.start("SplashState", true, false);
        }
    }

    public static loadRewardedAd(): void {

        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk
              .preloadAd('rewarded')
              .then((response: any) => {
                // A rewarded ad can be shown to user when he/she clicked it.
              })
              .catch((error: any) => {
                // Any Rewarded ad is not available to user.
              });
          }
    }

    public static initGameDistributionSDK(): void {

        window["GD_OPTIONS"] = {
            "gameId": "1b52d7c4cad04672891412279ebbbe5d",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        GameManager.game.paused = false;
                        if (GameVars.typeAd === "MainMenu") {
                            BoardManagerAI.leaveRoom();
                        } else if (GameVars.typeAd === "Reset") {
                            GameManager.rematch();
                        } else if (GameVars.typeAd === "Start") {
                            GameManager.vsComputerGameChosen();
                        } else if (GameVars.typeAd === "ProblemsMenu") {
                            GameManager.enterProblemSelectionState(GameVars.puzzleMoves);
                        } else if (GameVars.typeAd === "ResetProblems") {
                            GameManager.startChallengeState(true);
                        } else if (GameVars.typeAd === "Hint") {
                            ChallengeManager.useHint();
                        }
                        break;
                    case "SDK_GAME_PAUSE":
                        GameManager.game.paused = true;
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
    }

    public static enterProblemSelectionState(puzzleMoves: number, gameEnded?: boolean): void {

        GameVars.puzzleMoves = puzzleMoves;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED && gameEnded) {
            LaggedAPI.APIAds.show("interstitial", "go-chicken-go", "go-chicken-go-game.png", function(response: any) {
                if (response.success) {
                    console.log("ad done");
                    GameManager.game.state.start("PuzzleSelectionState", true, false);
                } else {
                    console.log("ad error, continue");
                    GameManager.game.state.start("PuzzleSelectionState", true, false);
                }
            });
        } else {
            GameManager.game.state.start("PuzzleSelectionState", true, false);
        }
    }

    public static vsComputerGameChosen(): void {

        AudioManager.setMusicVolume(.5);

        GameManager.startGameVSComputer();
    }

    public static oncPuzzleChosen(level: string, key: string): void {

        GameVars.currentLevelName = level;
        GameVars.gameData.lastProblems[GameVars.puzzleMoves - 2] = key;
        GameManager.saveGameData();

        GameManager.goToChallenge(key);

        GameManager.problemPlayed();

        // GameManager.enterHomeScene();
    }

    public static onClickNewGame(): void {

        GameManager.game.state.start("SplashState", true, false);
    }

    public static startGameVSComputer(): void {

        GameVars.againstAI = true;
        GameVars.challenge = false;
        GameManager.game.state.start("BoardState", true, false);
    }

    public static onGameEnd(ranks?: any): void {

        if (GameConstants.BOT_DEVELOPMENT) {

            // habria que saber si la partida ha acabado en tablas, jaque mate o el bot se ha rendido
            if (BoardState.currentInstance) {
                BoardState.currentInstance.checkmate();
                GameVars.gameFinished = false;
            }
        }
    }

    public static rematch(): void {

        GameManager.resetVars();

        if (GameVars.againstAI) {

            GameManager.vsComputerGameChosen();

        } else {

            GameVars.playingWithFriend = true;
        }
    }

    public static problemSolved(): void {

        if (GameVars.gameData.solvedProblems[GameVars.currentLevel] !== GameConstants.SOLVED) {
            GameVars.showLevelCompleted = true;
            GameVars.gameData.solvedProblems[GameVars.currentLevel] = GameConstants.SOLVED;
            GameVars.gameData.solvedCount[GameVars.puzzleMoves - 2]++;

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
                GameManager.checkAchievements(GameVars.puzzleMoves);
            }

            GameManager.saveGameData();
        }
    }

    public static checkAchievements(moves: number): void {

        var api_awards: string[] = [];
        var solved = GameVars.gameData.solvedCount;

        if (moves === 2) {
            if (solved[moves - 2] === 5) {
                api_awards.push("chess_grandmasterg_avb0001");
            } else if (solved[moves - 2] === 15) {
                api_awards.push("chess_grandmasterg_avb0002");
            } else if (solved[moves - 2] === 25) {
                api_awards.push("chess_grandmasterg_avb0003");
            } else if (solved[moves - 2] === 50) {
                api_awards.push("chess_grandmasterg_avb0004");
            }
        } else if (moves === 3) {
            if (solved[moves - 2] === 5) {
                api_awards.push("chess_grandmasterg_avb0005");
            } else if (solved[moves - 2] === 15) {
                api_awards.push("chess_grandmasterg_avb0006");
            } else if (solved[moves - 2] === 25) {
                api_awards.push("chess_grandmasterg_avb0007");
            } else if (solved[moves - 2] === 50) {
                api_awards.push("chess_grandmasterg_avb0008");
            }
        } else if (moves === 4) {
            if (solved[moves - 2] === 5) {
                api_awards.push("chess_grandmasterg_avb0009");
            } else if (solved[moves - 2] === 15) {
                api_awards.push("chess_grandmasterg_avb0010");
            } else if (solved[moves - 2] === 25) {
                api_awards.push("chess_grandmasterg_avb0011");
            } else if (solved[moves - 2] === 50) {
                api_awards.push("chess_grandmasterg_avb0012");
            }
        }

        LaggedAPI.Achievements.save(api_awards, function(response: any) {
            if (response.success) {
                console.log("achievement saved");
            } else {
                console.log(response.errormsg);
            }
        });
    }

    public static problemPlayed(): void {

        if (GameVars.gameData.solvedProblems[GameVars.currentLevel] === GameConstants.UNSOLVED) {
            GameVars.gameData.solvedProblems[GameVars.currentLevel] = GameConstants.PLAYED;
            GameManager.saveGameData();
        }
    }

    public static onTurnChange(playerID: string): void {
        // no hacemos nada
    }

    public static leaveRoom(): void {

        GameManager.game.state.start("SplashState", true, false);
    }

    public static getGameStorageData(key: string, successCb: Function, failureCb: Function): void {

        let data = localStorage.getItem(key);
        successCb(data);
    }

    public static setGameStorageData(key: string, value: any): void {

        localStorage.setItem(key, JSON.stringify(value));
    }

    public static onStatsDataSaved(): void {

        GameManager.log("stats data saved");
    }

    public static onStatsSavingFailed(error: Error): void {

        GameManager.log("failed to save stats data!", error);
    }

    public static onStatsDataRetrieved(statsData: string): void {

        if (statsData) {

            GameVars.globalStatsData = JSON.parse(statsData);

        } else {

            let friendsStatsData: StatsData = {gamesWon: 0, gamesDrawn: 0, gamesLost: 0, totalTimePlayed: 0, totalMoves: 0 };
            let randomStatsData: StatsData = {gamesWon: 0, gamesDrawn: 0, gamesLost: 0, totalTimePlayed: 0, totalMoves: 0 };
            let computerStatsData: StatsData = {gamesWon: 0, gamesDrawn: 0, gamesLost: 0, totalTimePlayed: 0, totalMoves: 0 };

            GameVars.globalStatsData = {friendsStatsData: friendsStatsData, randomStatsData: randomStatsData, computerStatsData: computerStatsData};
        }
    }

    public static onPause(): void {

        GameManager.game.sound.mute = true;
    }

    public static onResume(): void {

        if (!AudioManager.isMuted) {
            GameManager.game.sound.mute = false;
        }
    }

    public static changeTimerPreferences(isTimerOn: boolean, fromSettingslayer?: boolean): void {

        GameVars.isTimerOn = isTimerOn;

        let source = fromSettingslayer ? "homescreen" : "ingame";

        GameManager.setGameStorageData(GameConstants.TIMER_KEY, GameVars.isTimerOn);

        if (BoardState.currentInstance) {
            BoardState.currentInstance.hud.timerVisibilityStatusChanged();
        }
    }


    public static startTowerState(): void {
        GameManager.game.state.start("TowerState", true, false);
    }

    public static goToChallenge(id: string): void {

        AudioManager.setMusicVolume(.5);

        GameVars.currentLevel = id;
        GameManager.startChallengeState();
    }

    public static startChallengeState(gameEnded?: boolean): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED && gameEnded) {
            LaggedAPI.APIAds.show("interstitial", "go-chicken-go", "go-chicken-go-game.png", function(response: any) {
                if (response.success) {
                    console.log("ad done");
                    GameManager.game.state.start("ChallengeState", true, false);
                } else {
                    console.log("ad error, continue");
                    GameManager.game.state.start("ChallengeState", true, false);
                }
            });
        } else {
            GameManager.game.state.start("ChallengeState", true, false);
        }
    }

    public static capturedPiecesVisibilityChanged(isPlayer: boolean, isVisible: boolean) {

        if (isPlayer) {

            GameVars.playerCapturedPiecesVisible = isVisible;

            GameManager.setGameStorageData(GameConstants.PLAYER_CAPTURED_PIECES_KEY, GameVars.playerCapturedPiecesVisible);
        } else {

            GameVars.adversaryCapturedPiecesVisible = isVisible;

            GameManager.setGameStorageData(GameConstants.ADVERSARY_CAPTURED_PIECES_KEY, GameVars.adversaryCapturedPiecesVisible);
        }
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":",  error);
        } else {
            console.log(text);
        }
    }

    public static saveGameData(): void {
        GameManager.setGameStorageData(GameConstants.GAME_DATA_KEY, GameVars.gameData);
    }

    private static readGameStorage(): void {

        // el estado del audio
        GameManager.getGameStorageData( GameConstants.TIMER_KEY, 
            function(value: string): void {
                if (typeof value !== "undefined") {
                    GameVars.isTimerOn = JSON.parse(value) === true;
                } else {
                    GameVars.isTimerOn = true;
                }
            }, 
            function(error: Error): void {
                GameManager.log("failed to retrieve timer status", error);
            }
        );

        // game data
        GameManager.getGameStorageData( GameConstants.GAME_DATA_KEY, 
            function(value: string): void {
                if (value !== "undefined" && value !== null) {
                    GameVars.gameData = JSON.parse(value);
                } else {
                    GameVars.gameData = {
                        solvedProblems: GameManager.newSolvedProblems(),
                        solvedCount: [0, 0, 0],
                        lastProblems: ["2_0", "3_0", "4_0"],
                        lastTimestamp: 0,
                        numHints: 5
                    }
                }
            }, 
            function(error: Error): void {
                GameManager.log("failed to retrieve timer status", error);
            }
        );

        // captured pieces
        GameManager.getGameStorageData( GameConstants.PLAYER_CAPTURED_PIECES_KEY, 
            function(value: string): void {
                if (value !== "undefined" && value !== null) {
                    GameVars.playerCapturedPiecesVisible = JSON.parse(value);
                } else {
                    GameVars.playerCapturedPiecesVisible = true;
                }
            }, 
            function(error: Error): void {
                GameManager.log("failed to retrieve timer status", error);
            }
        );

        GameManager.getGameStorageData( GameConstants.ADVERSARY_CAPTURED_PIECES_KEY, 
            function(value: string): void {
                if (value !== "undefined" && value !== null) {
                    GameVars.adversaryCapturedPiecesVisible = JSON.parse(value);
                } else {
                    GameVars.adversaryCapturedPiecesVisible = true;
                }
            }, 
            function(error: Error): void {
                GameManager.log("failed to retrieve timer status", error);
            }
        );
    }

    private static newSolvedProblems(): { [key: string]: string; } {

        let solvedProblems: { [key: string]: string; } = {};

        for (let key in GameVars.problemsData) {
            if (GameVars.problemsData.hasOwnProperty(key)) {
                solvedProblems[key] = GameConstants.UNSOLVED;
            }
        }

        return solvedProblems;
    }

    private static resetVars(): void {

        GameVars.firstTimeSplash = true;
        GameVars.difficulty = GameConstants.DIFFICULTY_EASY;
        GameVars.fen = GameConstants.FEN_START;
        GameVars.bot = false;
        GameVars.colorAndDifficultyUnselected = true;
        GameVars.colorPlayer = null;
        GameVars.inviting = false;
        GameVars.capturedPieces = [];
        GameVars.gameFinished = false;
        GameVars.time = null;
        GameVars.startTime = null;
        GameVars.playingWithFriend = true;
        GameVars.lastMessageID = null;
        GameVars.ranks = null;
        GameVars.moves = 0;
        GameVars.playerResigned = false;
        GameVars.timeOut = false;
        GameVars.playerResignedAIGame = false;

        GameVars.challenge = false;
        GameVars.currentLevel = "2_0";
        GameVars.levelMoves = 1;
    }
}
